import * as React from 'react';
import { isWhiteLabel } from '@/redux/modules/whiteLabel';
import LAFooter from './LAFooter/LAFooter';
import { useSelector } from 'react-redux';
import WhiteLabelFooter from './WhiteLabelFooter/WhiteLabelFooter';

const Footer = () => {
    const whiteLabel = useSelector(isWhiteLabel);
    return whiteLabel ? <WhiteLabelFooter /> : <LAFooter />;
};

export default React.memo(Footer);
